import "./style.less";

export default function LaneGallery() {
    return {
        restrict: "E",
        scope: {
            laneId: "<",
            image: "<",
            images: "<", // array of image urls
        },
        template: require("./template.html"),

        controller: function ($scope, houseService) {
            $scope.galleryIsReady = false;

            if ($scope.images) {
                $scope.preparedGalleryImages = prepareGallery($scope.images);
            }

            // so you will bind openGallery method to a button on page
            // to open this gallery like data-ng-click="openGallery();"
            $scope.open = () => {
                if (!$scope.image) {
                    return false;
                }

                if ($scope.preparedGalleryImages.length) {
                    openGallery($scope.preparedGalleryImages);
                }

                if ($scope.preparedGalleryImages.length == 0) {
                    // API CALL getHousesInline - add

                    if (!$scope.laneId) {
                        return false;
                    }

                    const aOfHouseIds = [$scope.laneId];

                    houseService.getHousesInline(aOfHouseIds).then(
                        (res) => {
                            openGallery(prepareGallery(res[0].Images));
                        },
                        (err) => {}
                    );
                }
                //  else {
                //     openGallery(prepareGallery($scope.images));
                // }

                // You can also open gallery model with visible image index
                // Image at that index will be shown when gallery modal opens
                //scope.methods.open(index);
            };

            // // gallery methods
            $scope.methods = {};

            const prepareGallery = (images) => {
                return images.map((image, index) => {
                    /** More gallery image prop options
                     *  https://github.com/thatisuday/ng-image-gallery
                     */

                    return {
                        id: index,
                        url: image.URL,
                        alt: image.Alt,
                    };
                });
            };

            const openGallery = (preparedGalleryImages) => {
                $scope.preparedGalleryImages = preparedGalleryImages;
                $scope.galleryIsReady = true;
                $scope.methods.open();
            };

            // Similar to above function
            // $scope.closeGallery = function(){
            //     $scope.methods.close();
            // };

            // $scope.nextImg = function(){
            //     $scope.methods.next();
            // };

            // $scope.prevImg = function(){
            //     $scope.methods.prev();
            // };
        },
    };
}
